import { Reducer } from "redux";

import { SsoHpsClaimsStatusResponse } from "../models/api/Referral";
import { SsoHpsClaimsStatusUrlActionDispatchTypes } from "../constants/User";
import { UserPageTrackSsoHpsClaimsStatusUrlActionTypes } from "../models/dispatchTypes/User";

const initialState: SsoHpsClaimsStatusResponse = {
  loading: false,
  response: {
    ssoUrl: "",
    samlResponse: "",
    relayState: "",
  },
  error: null,
};

const GetSsoHpsClaimsStatusReducer: Reducer<
  SsoHpsClaimsStatusResponse,
  UserPageTrackSsoHpsClaimsStatusUrlActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SsoHpsClaimsStatusUrlActionDispatchTypes.SSO_HPS_CLAIMS_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SsoHpsClaimsStatusUrlActionDispatchTypes.SSO_HPS_CLAIMS_STATUS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SsoHpsClaimsStatusUrlActionDispatchTypes.SSO_HPS_CLAIMS_STATUS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case SsoHpsClaimsStatusUrlActionDispatchTypes.SSO_HPS_CLAIMS_STATUS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GetSsoHpsClaimsStatusReducer;
